export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/v4/common/icon-sort-like-light-baca01e877558fdb5e190396f3adc38f.svg";